import React from 'react';
import Icon from 'ui/icon';
import Text from 'ui/text';
import * as Layout from './Layout';
import { ICheckBoxProps } from './types';

const CheckBox = React.forwardRef<HTMLInputElement, ICheckBoxProps>(
  (
    {
      name,
      checked,
      value,
      size,
      onChange,
      label,
      cypressAttribute,
      variant = 'default',
      disabled = false,
    },
    ref
  ) => {
    const { icon: iconFill, text: textColor } = Layout.checkboxVariants[variant];

    return (
      <Layout.Label
        data-cy={cypressAttribute && `${cypressAttribute}-checkbox-label`}
        disabled={disabled}
      >
        <Layout.Input
          type="checkbox"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          data-cy={cypressAttribute && `${cypressAttribute}-checkbox-input`}
          variant={variant}
          ref={ref}
          disabled={disabled}
        />
        <Layout.Check
          size={size}
          data-cy={cypressAttribute && `${cypressAttribute}-checkbox-check`}
          disabled={disabled}
        >
          {checked && <Icon fill={iconFill} stroke={iconFill} icon="CheckIcon" size="normal" />}
        </Layout.Check>
        {label && (
          <Text
            color={textColor}
            size="sm"
            cypressAttribute={cypressAttribute && `${cypressAttribute}-checkbox-text`}
          >
            {label}
          </Text>
        )}
      </Layout.Label>
    );
  }
);

export default CheckBox;
